<header class="flex header">
  <h2>{{ 'Lot_Detail_Modal_Title_Add' | translateWF: 'Add Lot' }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <form [formGroup]="lotForm">
    <div class="form-box">
      <label for="lotId" ariaRequired="true">{{ 'Lot_Detail_Modal_Name' | translateWF: 'Name' }}</label>
      <input pInputText type="text" id="lotId" formControlName="lotId" class="w-full" />
    </div>
  </form>
</section>

<footer>
  <p-button class="w-full" [label]="'Save' | translateWF: 'Save'" [disabled]="lotForm.invalid" (click)="onSave()" />
  <p-button class="w-full" [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
</footer>
